<ng-container *ngIf="user$ | async"> </ng-container>
<ng-container *ngIf="actions$ | async"> </ng-container>

<div class="profile-box info-box flex flex-col">
  <header class="accent">
    <div class="title" i18n>Удаление аккаунта</div>
  </header>

  <div class="flex justify-center content">
    <button mat-raised-button type="submit" color="warn" i18n (click)="onDeleteAccount()">УДАЛИТЬ АККАУНТ</button>
  </div>
</div>
